import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
import LazyLoad from "react-lazyload";
import { Modal, Button } from "react-bootstrap";
import { useState } from "react";

const Magazine = () => {
  const homeMenu = [
    { label: "Awards & Achievements", link: "/awardsAcheivements" },
    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },
    {
      label: "Careers",
      link: "/careers-openings",
      subMenu: [{ label: "Philosophy", link: "/philosophy" }],
    },
    { label: "School Calendar", link: "/calender" },
    {
      label: "Alumni",
      link: "",
      subMenu: [
        { label: "Admissions", link: "/admission" },
        { label: "Admissions IIT", link: "/admissionIIT" },
      ],
    },
    { label: "eMagazine", link: "/Magazine" },
    {
      label: "TAABIR Digital Dreams",
      link: "/digitaldreams",
    },
    {
      label: "CUET",
      link: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/CUET.pdf",
    },
  ];
  const [showModal, setShowModal] = useState(false);
  const [selectedMagazine, setSelectedMagazine] = useState({
    title: "",
    url: "",
  });

  const handleOpenModal = (title, url) => {
    setSelectedMagazine({ title, url });
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/apply.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Magazine"
                breadEnd="Magazine"
                breadMid="Magazine"
              />
            </div>
            <div className="col-md-12">
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>eMagazine 2025-26</Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex">
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "PRIMARY WING SEPTEMBER-DECEMBER",
                            "https://online.anyflip.com/wrkqw/fctd/mobile/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/1_6-SWvPRoVMhYxWAXAco_26NYXPqGDuc.JPG"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>PRIMARY WING SEPTEMBER-DECEMBER</p>
                      </div>

                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "MIDDLE & SENIOR WING SEPTEMBER-DECEMBER",
                            "https://online.anyflip.com/wrkqw/jhjo/mobile/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/zGEsYpXXwh48QHA3qPZ572Xo.JPG"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>MIDDLE & SENIOR WING SEPTEMBER-DECEMBER</p>
                      </div>

                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I Primary Block",
                            "https://online.anyflip.com/hjco/pwlq/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/hjcopwlq.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - I Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/hjco/xujb/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/hjcotqcn.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - I MIDDLE/HIGH SCHOOL</p>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="9">
                  <Accordion.Header>eMagazine 2024-25</Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex">
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - III Primary Block",
                            "https://online.anyflip.com/hjco/japn/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/hjcombpx.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - III Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - III MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/hjco/sjtc/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/hjcosjtc.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - III MIDDLE/HIGH SCHOOL</p>
                      </div>

                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II Primary Block",
                            "https://online.anyflip.com/hjco/bepr/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/hjcomfso.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - II Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/hjco/bftp/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/hjcolmtg.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - II MIDDLE/HIGH SCHOOL</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I Primary Block",
                            "https://online.anyflip.com/hjco/qaxj/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/hjcoqaxj.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - I Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/hjco/pgfc/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/hjcopgfc.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - I MIDDLE/HIGH SCHOOL</p>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>eMagazine 2023-24</Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex">
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - III MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/hjco/cecs/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cecs.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - III MIDDLE/HIGH SCHOOL </p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - III Primary Block",
                            "https://online.anyflip.com/hjco/zlcw/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/zlcw.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - III Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/hjco/gwpi/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lv231223-1.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - II MIDDLE/HIGH SCHOOL </p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II Primary Block",
                            "https://online.anyflip.com/hjco/bcaq/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/EMAG-AUG-NOV-PrimaryBlock.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - II Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I Primary Block",
                            "https://online.anyflip.com/hjco/egsd/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/emag-Primary-Block.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - I Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/hjco/prhm/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/EMAG_AUGUST-midd.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - I MIDDLE/HIGH SCHOOL </p>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>eMagazine 2022-23</Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex">
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - III Primary Block",
                            "https://online.anyflip.com/hjco/irpc/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cecs.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - III Primary Block </p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - III MIDDLE/HIGH",
                            "https://online.anyflip.com/hjco/tqro/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/zlcw.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - III MIDDLE/HIGH</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II Primary Block",
                            "https://online.anyflip.com/hjco/ihdm/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/lv231223-1.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - II Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II MIDDLE/HIGH",
                            "https://online.anyflip.com/hjco/wbsl/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/EMAG-AUG-NOV-PrimaryBlock.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - II MIDDLE/HIGH</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I Primary Block",
                            "https://online.anyflip.com/hjco/yfgf/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/emag-Primary-Block.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - I Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I MIDDLE/HIGH SCHOOL ",
                            "https://online.anyflip.com/hjco/odhz/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/EMAG_AUGUST-midd.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - I MIDDLE/HIGH SCHOOL </p>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>eMagazine 2021-22</Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex">
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - III Primary Block",
                            "https://online.anyflip.com/hjco/japn/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/sdtqz-rgyc.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - III Primary Block </p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - III MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/hjco/ujvr/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/sdtqztnsr.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - III MIDDLE/HIGH SCHOOL</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II Primary Block",
                            "https://online.anyflip.com/hjco/vfra/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/hjco-vfra.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - II Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/hjco/ufay/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/hjco-ufay.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - II MIDDLE/HIGH SCHOOL</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I Primary Block",
                            "https://online.anyflip.com/hjco/lfie/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/hjco-lfie.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - I Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I MIDDLE/HIGH SCHOOLk",
                            "https://online.anyflip.com/hjco/walh/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/hjco-walh.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - I MIDDLE/HIGH SCHOOL </p>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>eMagazine 2020-21</Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex">
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - III MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/hjco/lpjz/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/dec-to-mar-2020-21-m.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - III MIDDLE/HIGH SCHOOL </p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - III Primary Block",
                            "https://online.anyflip.com/hjco/wenw/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/dec-to-mar-2020-21-p.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - III Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II Primary Block",
                            "https://online.anyflip.com/hjco/kvuf/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/E-MAG-II-QUARTER-Primary-editedfile-16-12-2020.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - II Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/hjco/dxyw/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/E-MAG-II-16-12-2020.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - II MIDDLE/HIGH SCHOOL</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I Primary Block",
                            "https://online.anyflip.com/ktds/hinr/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/apr-2020-2.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - I Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/ktds/bgkz/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/apr-2020-1.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - I MIDDLE/HIGH SCHOOL </p>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>eMagazine 2019-20</Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex">
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            " eMAGAZINE, VOLUME - III MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/ktds/ychx/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/dec-to-mar-2019-20-m.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - III MIDDLE/HIGH SCHOOL</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - III Primary Block",
                            "https://online.anyflip.com/ktds/xkhu/",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/dec-to-mar-2019-20-p.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - III Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/hjco/wfqb/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/August-to-November0-2019-20-m.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - II MIDDLE/HIGH SCHOOL</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II Primary Block",
                            "https://online.anyflip.com/hjco/dutk/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/August-to-November0-2019-20-p.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - II Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I Primary Block",
                            "https://online.anyflip.com/ktds/hmwb/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/April-July-2019-20-p.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - I Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/ktds/amky/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/April-July-2019-20.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - I MIDDLE/HIGH SCHOOL </p>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="6">
                  <Accordion.Header>eMagazine 2018-19</Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex">
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II Primary Block",
                            "https://online.anyflip.com/hjco/utty",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/School-emagazine-pre-School-April-July-2018-19-1.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - II Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/vcrdn/eopn/",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/School-emagazine-Middle-School-december-march-2018-19.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - II MIDDLE/HIGH SCHOOL</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II Primary Block",
                            "https://online.anyflip.com/hjco/lbwk",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/School-emagazine-pre-School-April-July-2018-19.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - II Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/hjco/hllr/",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/School-emagazine-Middle-School-aug-nov-2018-19.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p> eMAGAZINE, VOLUME - II MIDDLE/HIGH SCHOOL</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I Primary Block",
                            "https://online.anyflip.com/hjco/riek/mobile/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/School-E-magazine-Primary--School--April-July--2018-19.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - I Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/hjco/vzli/mobile/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/School-emagazine-Middle-School-April-July-2018-19.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - I MIDDLE/HIGH SCHOOL</p>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="7">
                  <Accordion.Header>eMagazine 2017-18</Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex">
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - III MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/qsyw/crsg/mobile/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/E_MAG_OCT_NOV_DEC.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - III MIDDLE/HIGH SCHOOL</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - III Primary Block",
                            "https://online.anyflip.com/hjco/fblt/mobile/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/E-mag_primary_Oct_DecFinal17.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - III Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/hjco/fblt/mobile/index.html",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/E_MAG_M_H_JULY-SEPT_17-1.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - II MIDDLE/HIGH SCHOOL</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II Primary Block",
                            "https://online.anyflip.com/hjco/fece/",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/E-mag_Primary_July-Sep17.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - II Primary Block</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I PRIMARY SCHOOL",
                            "https://online.anyflip.com/fxvq/ibpl/",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/E-mag_primary_Apr-June_17.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - I PRIMARY SCHOOL</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I MIDDLE/SENIOR SCHOOL",
                            "https://online.anyflip.com/fxvq/vquo/",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/E_MAG_M_H_APRIL-JUN _17.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - I MIDDLE/SENIOR SCHOOL</p>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="8">
                  <Accordion.Header>eMagazine 2016-17</Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex">
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - III PRIMARY SCHOOL",
                            "https://online.anyflip.com/eunc/lkfy/",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/primary-mar-20171497229308.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - III PRIMARY SCHOOL</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II PRIMARY SCHOOL",
                            "https://online.anyflip.com/eunc/joup/",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/primary-aug-oct-20161497229269.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - II PRIMARY SCHOOL</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - II MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/eunc/ozrt/",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/middle-high-aug-oct-20161497229237.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - II MIDDLE/HIGH SCHOOL</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I PRIMARY SCHOOL",
                            "https://online.anyflip.com/eunc/masy/",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/primary-apr-jul-20161497229194.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - I PRIMARY SCHOOL</p>
                      </div>
                      <div
                        className="magazine"
                        onClick={() =>
                          handleOpenModal(
                            "eMAGAZINE, VOLUME - I MIDDLE/HIGH SCHOOL",
                            "https://online.anyflip.com/eunc/dkbw/",
                          )
                        }
                      >
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/middle-high-apr-jul-20161497229133.jpg"
                            alt="Lotus Valley School, Gurgaon"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <p>eMAGAZINE, VOLUME - I MIDDLE/HIGH SCHOOL</p>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={handleCloseModal} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedMagazine.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          <iframe
            src={selectedMagazine.url}
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title={selectedMagazine.title}
          ></iframe>
        </Modal.Body>
      </Modal>

      <Footer />
    </>
  );
};
export default Magazine;
